/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSurveyChatsResult } from '../../models/get-survey-chats-result';

export interface GetChats$Params {
  PageIndex?: number;
  PageSize?: number;
}

export function getChats(
  http: HttpClient,
  rootUrl: string,
  params?: GetChats$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetSurveyChatsResult>> {
  const rb = new RequestBuilder(rootUrl, getChats.PATH, 'get');
  if (params) {
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSurveyChatsResult>;
    }),
  );
}

getChats.PATH = '/Surveys/chats';
